/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

/**
 * Interface to experiment choices.
 */
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

const _ = require('underscore');

const experimentGroupingRules = [require('./communication-prefs'), require('./is-sampled-user'), require('./sentry'), require('./push'), require('./third-party-auth')].map(ExperimentGroupingRule => new ExperimentGroupingRule());

let ExperimentChoiceIndex = /*#__PURE__*/function () {
  function ExperimentChoiceIndex() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ExperimentChoiceIndex);

    this._env = options.env;
    this._experimentGroupingRules = options.experimentGroupingRules || experimentGroupingRules;
    this._featureFlags = options.featureFlags;
  }
  /**
   * Use `subject` to make a choice for the experiment with `name`.
   *
   * @param {String} name
   * @param {Object} [subject={}]
   * @returns {Any}
   */


  _createClass(ExperimentChoiceIndex, [{
    key: "choose",
    value: function choose(name) {
      let subject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      const experiment = _.find(this._experimentGroupingRules, experimentGroupingRule => experimentGroupingRule.name === name);

      if (experiment) {
        if (!isExperimentAllowed(experiment, subject)) {
          return false;
        } else if (useForceExperimentGroup(experiment, subject)) {
          return subject.forceExperimentGroup;
        } // A reference to `experimentGroupingRules` is passed in
        // `subject` to allow tests to recursively call other tests.
        // Passing via the `subject` instead of the constructor
        // avoids creating a circular reference between the parent
        // and the children.
        // A copy of subject is used so the original isn't modified.


        const subjectCopy = Object.create(subject);
        subjectCopy.env = subject.env || this._env;
        subjectCopy.experimentGroupingRules = this;
        subjectCopy.featureFlags = subject.featureFlags || this._featureFlags;
        return experiment.choose(subjectCopy);
      }
    }
  }]);

  return ExperimentChoiceIndex;
}();

ExperimentChoiceIndex.EXPERIMENT_NAMES = experimentGroupingRules.map(experimentGroupingRule => experimentGroupingRule.name);
module.exports = ExperimentChoiceIndex;

function isExperimentAllowed(experiment, subject) {
  // Functional tests use the forceExperiment & forceExperimentGroup query parameters
  // to force entry into a given experiment. When forcing a given experiment,
  // functional tests do not expect interference from other functional tests.
  // If forceExperiment and forceExperimentGroup are specified, *only* enter the
  // user into the experiment whose name matches forceExperimentGroup. Ignore
  // all other experiments unless they are explicitly allowed.
  return !subject.forceExperiment || allowExperimentWithForceExperiment(experiment, subject.forceExperiment);
}

function allowExperimentWithForceExperiment(experiment, forceExperiment) {
  return forceExperiment === experiment.name || forceExperiment === experiment.forceExperimentAllow;
}

function useForceExperimentGroup(experiment, subject) {
  return subject.forceExperiment && subject.forceExperimentGroup && subject.forceExperiment === experiment.name;
}